import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 570px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 160px;
`;

export const Warning = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-align: left;
  color: ${({ theme }) => theme.colors.main};
  text-transform: uppercase;
  padding: 7px 20px;
`;

export const ConfirmData = styled.div`
  text-align: center;
  margin: auto;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  color: ${({ theme }) => theme.colors.text};
  padding: 0 0 24px;
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  button {
    display: inline-block;
    vertical-align: top;
    margin-right: 6px;
  }
`;
